<blaze-inline-date
  #inlineDateComponent
  [config]="config()"
  [value]="dateValue()"
  (valueChanged)="dateUpdated($event)"
  (pickerOpened)="datePickerOpened()"
/>

<blaze-inline-time
  #inlineTimeComponent
  [config]="config()"
  [value]="timeValue()"
  (valueChanged)="timeUpdated($event)"
  (pickerOpened)="timePickerOpened()"
/>
